module.exports = __webpack_public_path__ + "static/img/united-states.218f936.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/united-states.png
// module id = Xjnw
// module chunks = 3